<template lang="pug">
  v-container(grid-list-xl fluid)
    v-layout(wrap)
      v-flex(xs12 md9 lg10)
        v-data-table.elevation-1(
          v-model="selected"
          select-allX
          :headers="headers"
          :items="patientenverfuegungen"
          must-sortX
          :pagination="queryFilterPagination"
          @update:pagination="queryFilterPaginationUpdate($event)"
          :total-items="patientenverfuegungenCount"
          :loading="$apollo.queries.patientenverfuegungen.loading"
          :rows-per-page-items="[10,25,50,100,500,{text: 'Alle', value: -1}]"
          rows-per-page-text="Zeilen pro Seite:"
          no-data-text="Keine Patientenverfügungen"
        )
          template(slot="items" slot-scope="props")
            td: v-checkbox(primary hide-details v-model="props.selected")
            td: v-btn(icon @click="edit = props.item.id"): v-icon edit
            td {{props.item.id}}
            td {{props.item.vorname}}
            td {{props.item.nachname}}
            td {{props.item.status}}
            td {{props.item.dringlichkeit}}
        pvEdit(v-model="edit" :url2pdfHost="url2pdfHost")
        v-menu(offset-y bottom open-on-hover style="display: block")
          v-fab-transition(slot="activator")
            v-btn(icon top left fixed small fab  dark color="primary" style="left: 25px; top: 12px" v-show="!!selected.length" :loading="stapelActionLoading > 0")
              v-icon more_vert
          v-list
            v-list-tile(@click="generateCsv"): v-list-tile-title  CSV aus ausgewählten generieren
      v-flex(xs12 md3 lg2)
        v-card
          v-card-text
            v-text-field(label="Vorname" :value="$route.query.vorname" @input="queryFilterUpdate('vorname', $event)")
            v-text-field(label="Nachname" :value="$route.query.nachname" @input="queryFilterUpdate('nachname', $event)")
            radio-group(label="Dringlichkeit" row :items="dringlichkeiten" :value="$route.query.dringlichkeit" @change="queryFilterUpdate('dringlichkeit', $event)")
            radio-group(label="Status" row :items="statenFilter" :value="$route.query.status" @change="queryFilterUpdate('status', $event)")

</template>

<script>
import gql from 'graphql-tag'
import queryFilter from '../../mixins/query-filter'
import pvEdit from './extra-patientenverfuegung/pv-edit.vue'

export default {
  props: ['extra'],
  mixins: [queryFilter],
  components: {
    pvEdit
  },
  data() {
    return {
      edit: null,
      html: null,
      stapelActionLoading: 0,
      printUeberweisungData: null,
      printPatientenverfuegungData: null,
      selected: [],
      patientenverfuegungenCount: 0,
      patientenverfuegungen: [],
      headers: [
        { text: "", sortable: false },
        { text: "", sortable: false },
        { text: "ID", sortable: false },
        { text: "Vorname", sortable: false },
        { text: "Nachname", sortable: false },
        { text: "Status", sortable: false },
        { text: "Dringlichkeit", sortable: false },
      ],
      dringlichkeiten: [
        { text: "Alle", value: null },
        { text: "Normal", value: "normal" },
        { text: "Dringend", value: "dringend" },
      ],
      staten: [
        { text: "Neu", value: "neu" },
        { text: "In Bearbeitung", value: "in_bearbeitung" },
        { text: "Abgeschlossen", value: "abgeschlossen" },
        { text: "test", value: "test" },
      ],
      statenFilter: [
        { text: "Alle", value: null },
        { text: "Neu", value: "neu" },
        { text: "In Bearbeitung", value: "in_bearbeitung" },
        { text: "Abgeschlossen", value: "abgeschlossen" },
        { text: "test", value: "test" },
      ]
    }
  },
  apollo: {
    url2pdfHost: gql`{ url2pdfHost }`,
    patientenverfuegungen: {
      query: gql`query ExtraPatientenverfuegungVue($where: PatientenverfuegungWhereInput) {
        patientenverfuegungen(where: $where, order: "id:desc") {
          id
          status
          vorname
          nachname
          dringlichkeit
          betrag
          data
        }
        patientenverfuegungenCount(where: $where)
      }`,
      fetchPolocy: 'network-only',
      variables() {
        return { where: this.query }
        // return { where: this.query ,q: JSON.stringify(this.query) }
      },
      update(response) {
        this.patientenverfuegungenCount = response.patientenverfuegungenCount
        return response.patientenverfuegungen
      }
    }
  },
  computed: {
    data() {
      return JSON.parse(this.patientenverfuegungen && this.patientenverfuegungen[0] && this.patientenverfuegungen[0].data || null)
    },
    query() {
      const f = this.$route.query
      const and = []
      const q = { }
      if (f.status) {
        q.status = f.status
      }
      if (f.vorname) {
        and.push({ dataContains: { p: "vorname", v: f.vorname }})
      }
      if (f.nachname) {
        and.push({ dataContains: { p: "nachname", v: f.nachname }})
      }
      if (f.dringlichkeit) {
        and.push({ data: { p: "dringlichkeit", v: f.dringlichkeit }})
      }
      q.AND = and
      return q
    },
  },
  methods: {
    async generateCsv(){
      this.stapelActionLoading++
      try{
      const resp = await this.$http.post(`/admin/pv_auftraege/abgeschlossene_pvs_csv.csv`, { ids: this.selected.map((pv) => pv.id) }, { responseType: 'blob', headers: { "Content-Type": "application/json" } })
        const blob = await resp.blob()
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      } finally {
        this.stapelActionLoading--
      }
    },
    printUeberweisung(item) {
      this.printUeberweisungData = item
      this.$nextTick(async () => {
        let html = this.$refs.printUeberweisung.$el.innerHTML
        html = html.replace(/style-workaround/g, 'style')
        html = `<html><head><meta charset="utf-8"/></had><body>${html}</body></html>`
        this.html = html
        const resp = await this.$http.post(`${this.url2pdfHost}/api/render`, { html: html, pdf: { width: "14.8cm", height: "10.5cm" } }, { responseType: 'blob', headers: { "Content-Type": "application/json" } })
        const blob = await resp.blob()
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      })
    },
    printPatientenverfuegung(item) {
      this.printPatientenverfuegungData = null
      this.$nextTick(() => {
        this.printPatientenverfuegungData = item
      })
    },
    async printComponent(component, pageSize) {
        let html = component.$el.innerHTML
        html = html.replace(/style-workaround/g, 'style')
        html = `<html><head><meta charset="utf-8"/></had><body>${html}</body></html>`
        this.html = html
        const resp = await this.$http.post(`${this.url2pdfHost}/api/render`, { html: html, pdf: { format: "A4" } }, { responseType: 'blob', headers: { "Content-Type": "application/json" } })
        const blob = await resp.blob()
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
    },
    download(name, ext, type, content) {
      const url = window.URL.createObjectURL(new Blob([content], { type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${name.replace(/[^a-z0-9äüöß_ -]+/gi, '-').replace(/-+/, '-').replace(/^-+|-+$/g, '')}.${ext}`)
      document.body.appendChild(link)
      link.click()
    }
  },
}
</script>
